import axios from "axios";

export default {
  // GET Methods
  getMembersRestricted(bookNum) {
    return axios
      .get("/" + process.env.CHAPTER_NUMBER + "/members/restricted/" + bookNum)
      .then(response => {
        return response;
      })
      .catch(err => {
        return err.response;
      });
  },
  getMembers(token, path = "") {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token
      }
    };

    var url =
      "/" +
      process.env.CHAPTER_NUMBER +
      "/members" +
      (path === "" ? "" : "?" + path);

    return axios.get(url, axiosConfig).then(response => {
      return response.data;
    });
  },
  getMember(token, bookNum) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token
      }
    };

    return axios
      .get(
        "/" + process.env.CHAPTER_NUMBER + "/members/" + bookNum,
        axiosConfig
      )
      .then(res => {
        return res.data;
      })
      .catch(err => console.log("AXIOS ERROR: ", err));
  },
  validateBookNum(bookNum) {
    return axios
      .get(
        "/" + process.env.CHAPTER_NUMBER + "/members/" + bookNum + "/validate"
      )
      .then(response => {
        return response.data.valid;
      });
  },
  getOptions(token) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token
      }
    };

    return axios
      .get("/" + process.env.CHAPTER_NUMBER + "/members/options", axiosConfig)
      .then(res => res.data)
      .catch(err => console.log("AXIOS ERROR", err));
  },
  submitSearch(token, path) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token
      }
    };

    return axios
      .get(
        "/" + process.env.CHAPTER_NUMBER + "/members/search" + path,
        axiosConfig
      )
      .then(res => res.data)
      .catch(err => console.log("AXIOS ERROR", err));
  },
  // POST Methods
  postNewMember(token, info) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token
      }
    };

    return axios
      .post("/" + process.env.CHAPTER_NUMBER + "/members", info, axiosConfig)
      .then(res => {
        return res.data;
      })
      .catch(err => {
        console.log("AXIOS ERROR: ", err);
        throw err.response;
      });
  },
  //PUT Methods
  putEditedMember(token, bookNum, info) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token
      }
    };

    return axios
      .put(
        "/" + process.env.CHAPTER_NUMBER + "/members/" + bookNum,
        info,
        axiosConfig
      )
      .then(res => res.data)
      .catch(err => console.log("AXIOS ERROR: ", err));
  },
  resetMember(token, bookNum) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token
      }
    };

    return axios
      .put(
        "/" + process.env.CHAPTER_NUMBER + "/members/" + bookNum + "/reset",
        {},
        axiosConfig
      )
      .then(res => res.data)
      .catch(err => console.log("AXIOS ERROR: ", err));
  },
  // DELETE Methods
  deleteMember(token, bookNum) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token
      }
    };

    return axios
      .delete(
        "/" + process.env.CHAPTER_NUMBER + "/members/" + bookNum,
        axiosConfig
      )
      .then(res => res.data)
      .catch(err => console.log("AXIOS ERROR: ", err));
  }
};



// WEBPACK FOOTER //
// ./src/utils/api/members.js